import { createElement, useCallback, useState } from 'react';
import { UndoRedoProps } from '.';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { postfixTestId } from '../../util/testId';
import { Flow } from '../Layouts/Flow';
import { ContextMenuButton, getUndoRedoProps, useActionManager } from './__internal__';
import bundle from './NovaComponents-UndoRedo-gui-icu.properties';

import { Redo, Undo } from '@sas/react-svg';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const UndoRedo = (props: UndoRedoProps) => {
  const [{ undoProps, redoProps }, setUndoRedoProps] = useState(() =>
    getUndoRedoProps(props.actionManager)
  );
  const actionHistoryChangedHandler = useCallback(() => {
    setUndoRedoProps(getUndoRedoProps(props.actionManager));
  }, [props.actionManager]);
  useActionManager(props.actionManager, actionHistoryChangedHandler);

  const localize = useTextLocalizer();
  const undoItems = undoProps.sections[0].items;
  const redoItems = redoProps.sections[0].items;
  const undoTooltip =
    undoItems.length > 0
      ? localize('undoRecent.tooltip.label', { item: undoItems[0].text })
      : undefined;
  const redoTooltip =
    redoItems.length > 0
      ? localize('redoRecent.tooltip.label', { item: redoItems[0].text })
      : undefined;

  return (
    <Flow spacing="s">
      <ContextMenuButton
        testId={postfixTestId(props.testId, 'undoButton')}
        ref={props.undoBtnRef}
        icon={{ icon: Undo }}
        tooltip={undoTooltip}
        focusable={props.undoFocusable}
        {...undoProps}
      />
      <ContextMenuButton
        testId={postfixTestId(props.testId, 'redoButton')}
        ref={props.redoBtnRef}
        icon={{ icon: Redo }}
        tooltip={redoTooltip}
        focusable={props.redoFocusable}
        {...redoProps}
      />
    </Flow>
  );
};
